import { render } from "./ChartsFromJSONView.vue?vue&type=template&id=4793c386"
import script from "./ChartsFromJSONView.vue?vue&type=script&lang=js"
export * from "./ChartsFromJSONView.vue?vue&type=script&lang=js"

import "./ChartsFromJSONView.vue?vue&type=style&index=0&id=4793c386&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__